// extracted by mini-css-extract-plugin
module.exports = {"clipText":"ClipText_clipText__91jPl"};